import image from '../../img/layouts/layout-preview-content-below.png';

export const preview = {
  image,
  description: 'Content Below',
};
